/* Waïloa – filtres façon ASOS (collections et recherche).
   Desktop : menus déroulants dans une barre, un seul ouvert à la fois, mise à jour immédiate.
   Mobile : panneau plein écran, mise à jour en direct du nombre de produits.
   Rendu par section (section_id) : pas de rechargement ; en cas d'erreur, navigation classique. */
(function () {
  var busy = 0;
  var mqDesk = window.matchMedia('(min-width: 990px)');

  function box() { return document.querySelector('[data-wl-facets]'); }
  function form() { var b = box(); return b && b.querySelector('[data-wlfx-form]'); }

  function paramsFromForm(f) {
    var fd = new FormData(f), p = new URLSearchParams();
    fd.forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
    return p.toString();
  }
  function urlFor(qs) { return location.pathname + (qs ? '?' + qs : ''); }

  function closeAll(except) {
    var b = box(); if (!b) return;
    b.querySelectorAll('.wlfx__group[open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }
  function openDrawer() {
    var b = box(); if (!b) return;
    b.classList.add('is-open');
    document.documentElement.classList.add('wlfx-lock');
    var btn = b.querySelector('[data-wlfx-open]'); if (btn) btn.setAttribute('aria-expanded', 'true');
    var x = b.querySelector('.wlfx__x'); if (x) setTimeout(function () { x.focus(); }, 50);
  }
  function closeDrawer() {
    var b = box(); if (!b) return;
    b.classList.remove('is-open');
    document.documentElement.classList.remove('wlfx-lock');
    var btn = b.querySelector('[data-wlfx-open]'); if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
  }

  function render(url, push) {
    var b = box(); if (!b) { location.href = url; return; }
    var sid = b.dataset.sid;
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', sid);
    var my = ++busy;
    var grid = document.getElementById('CollectionProductsContainer');
    if (grid) { grid.classList.add('wl-busy'); grid.setAttribute('aria-busy', 'true'); }
    fetch(u.pathname + u.search, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (my !== busy) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nb = doc.querySelector('[data-wl-facets]');
        if (nb) {
          /* Valeurs, compteurs et badges mis à jour groupe par groupe (les menus ouverts le restent) */
          b.querySelectorAll('[data-wlfx-group]').forEach(function (g) {
            var ng = nb.querySelector('[data-wlfx-group="' + g.dataset.wlfxGroup + '"]');
            if (!ng) return;
            var p = g.querySelector('[data-wlfx-panel]'), np = ng.querySelector('[data-wlfx-panel]');
            var focusId = document.activeElement && g.contains(document.activeElement) ? document.activeElement.id : null;
            if (p && np && g.dataset.wlfxGroup !== 'sort') p.innerHTML = np.innerHTML;
            var n = g.querySelector('[data-wlfx-n]'), nn = ng.querySelector('[data-wlfx-n]');
            if (n && nn) n.textContent = nn.textContent;
            g.classList.toggle('is-active', ng.classList.contains('is-active'));
            if (focusId) { var el = document.getElementById(focusId); if (el) el.focus({ preventScroll: true }); }
          });
          ['[data-wlfx-active]', '[data-wlfx-badge]'].forEach(function (sel) {
            var a = b.querySelector(sel), na = nb.querySelector(sel);
            if (a && na) { a.innerHTML = na.innerHTML; a.hidden = na.hidden; }
          });
          var counts = nb.querySelectorAll('[data-wlfx-count]');
          b.querySelectorAll('[data-wlfx-count]').forEach(function (c, i) { if (counts[i]) c.innerHTML = counts[i].innerHTML; });
        }
        var ng2 = doc.getElementById('CollectionProductsContainer');
        if (grid && ng2) {
          grid.innerHTML = ng2.innerHTML;
          grid.querySelectorAll('[data-aos]').forEach(function (el) { el.classList.add('aos-animate'); });
          if (typeof window.wlAfterRender === 'function') { try { window.wlAfterRender(grid); } catch (e) {} }
          if (typeof window.wlWatchInfinite === 'function') { try { window.wlWatchInfinite(); } catch (e) {} }
          if (typeof window.loadMoreCollection === 'function') { try { window.loadMoreCollection(); } catch (e) {} }
          document.dispatchEvent(new CustomEvent('wl:products-rendered', { detail: { root: grid } }));
        }
        /* Page recherche : pagination et autres blocs */
        ['[data-serach-pagination]', '.searchbar__result-heading'].forEach(function (sel) {
          var a = document.querySelector(sel), na = doc.querySelector(sel);
          if (a) a.innerHTML = na ? na.innerHTML : '';
        });
        if (push !== false) { try { history.pushState({ wlfx: 1 }, '', url); } catch (e) {} }
      })
      .catch(function () { location.href = url; })
      .finally(function () {
        if (my === busy && grid) { grid.classList.remove('wl-busy'); grid.setAttribute('aria-busy', 'false'); }
      });
  }

  var t;
  document.addEventListener('change', function (e) {
    var f = form(); if (!f || !f.contains(e.target)) return;
    if (e.target.matches('[data-wlfx-price]')) return; /* prix : bouton Appliquer ou Entrée */
    clearTimeout(t);
    t = setTimeout(function () {
      render(urlFor(paramsFromForm(f)));
      if (e.target.name === 'sort_by' && mqDesk.matches) closeAll();
    }, 120);
  });
  document.addEventListener('submit', function (e) {
    var f = form(); if (!f || e.target !== f) return;
    e.preventDefault();
    render(urlFor(paramsFromForm(f)));
    if (mqDesk.matches) closeAll();
  });
  document.addEventListener('click', function (e) {
    var b = box(); if (!b) return;
    var a = e.target.closest('[data-wlfx-link]');
    if (a && b.contains(a)) { e.preventDefault(); render(a.getAttribute('href')); return; }
    if (e.target.closest('[data-wlfx-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-wlfx-close]')) { e.preventDefault(); closeDrawer(); return; }
    /* Desktop : un seul menu ouvert, fermeture au clic extérieur */
    var s = e.target.closest('.wlfx__sum');
    if (s && b.contains(s) && mqDesk.matches) { closeAll(s.parentNode); return; }
    if (mqDesk.matches && !e.target.closest('.wlfx__group')) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var b = box(); if (!b) return;
    if (b.classList.contains('is-open')) closeDrawer();
    else if (b.querySelector('.wlfx__group[open]')) {
      var o = b.querySelector('.wlfx__group[open]');
      o.removeAttribute('open');
      var s = o.querySelector('summary'); if (s) s.focus();
    }
  });
  window.addEventListener('popstate', function () { if (box()) render(location.href, false); });
  mqDesk.addEventListener && mqDesk.addEventListener('change', function () { closeAll(); if (mqDesk.matches) closeDrawer(); });
})();
